// extracted by mini-css-extract-plugin
export default {"section":"TimeLogsRulesModal_section__ZYh5u","sectionTitle":"TimeLogsRulesModal_sectionTitle__DeyXN","list":"TimeLogsRulesModal_list__8qI2S"};